import CouponsLotusDetails from './CouponsLotusDetails'

export default CouponsLotusDetails